/**
* In this file use to handel the Password View and Hidden Function
**/
import { useState } from 'react';


/** 
* This function used to handel the Password input field type
**/
const usePasswordToggle = (initialVisibility = false) => {
	
	//Intial state declaraction
  const [showPassword, setShowPassword] = useState(initialVisibility);

  //To handel the Password's field eyeicon click action
  const togglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return [showPassword, togglePassword];
};

export default usePasswordToggle;